import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ListOfSpacesBaseComponent } from '@shared/base-components/list-of-spaces.base.component';
import { Learnspace, LearnspaceUserRole, ListQueryOptions } from '@shared/models';
import { AuthenticationService } from '@shared/services/authentication.service';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { InternalAnalyticsService } from '@shared/services/internalAnalytics.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'hub-contribute-list',
  templateUrl: './hub-contribute-list.component.html',
  styleUrls: ['./hub-contribute-list.component.scss']
})
export class HubContributeListComponent extends ListOfSpacesBaseComponent implements OnInit {
  @Output() createProgramClicked = new EventEmitter<void>();
  @Output() cardClicked = new EventEmitter<Learnspace>();
  @Output() viewAllClicked = new EventEmitter<void>();

  learnspaces: Learnspace[] = [];
  isLoading = true;
  skeletonItems: unknown[] = [];
  canAddProgram = false;
  private readonly listSize = 3;

  constructor(
    courseApiService: CoursesAPIService,
    currentHub: CurrentHubService,
    authService: AuthenticationService,
    dialog: MatDialog,
    router: Router,
    activatedRoute: ActivatedRoute,
    internalAnalyticsService: InternalAnalyticsService
  ) {
    super(courseApiService, authService, dialog, router, activatedRoute, currentHub, internalAnalyticsService);
  }

  ngOnInit(): void {
    // Reload the list after any inherited action (edit / delete / leave)
    this.listUpdate.subscribe(() => this.loadPrograms(this._currentHub.hub.id));

    this._currentHub.hubObservable.subscribe(async (hub) => {
      if (hub) {
        this.isLoading = true;
        this.skeletonItems = Array(this.listSize);
        this.canAddProgram = this._currentHub.canManageCurrentHub();
        this.canCreateSpace = this._currentHub.canCreateSpace;
        this.hasRoleToCreateSpace = this._currentHub.canManageCurrentHub();
        await this.loadPrograms(hub.id);
      }
    });
  }

  duplicateLearnspace(ls: Learnspace): void {
    this._courseApiService
      .duplicateLearnspace(ls.id, this._currentHub.hub.id, true)
      .subscribe(() => this.loadPrograms(this._currentHub.hub.id));
  }

  getParticipantCount(ls: Learnspace): number | undefined {
    return ls.participantCount ? +ls.participantCount : undefined;
  }

  private async loadPrograms(hubId: string): Promise<void> {
    try {
      const options = new ListQueryOptions('status,-updatedAt', '', 0, this.listSize, true, LearnspaceUserRole.contributor);
      const result = await this._courseApiService.getLearnspacesJoinedByHub(hubId, options).toPromise();
      this.learnspaces = result.learnspaces;
      // Keep lsList in sync so the base unsubscribeToLearnspace index mutation doesn't throw
      this.lsList = this.learnspaces;
    } catch {
      this.learnspaces = [];
    } finally {
      this.isLoading = false;
    }
  }
}
